/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained

access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import { isStrEmptyOrNull } from '../common/UtilityFunctions';
import * as yup from 'yup';

export const schema = yup.lazy((value) => {
  let shapeObject = {
    DDSCode: yup.string(),
    investorDDSCode: yup.string(),
    dates: yup.object(),
    fhlmcCutoffActionCode: yup.string(),
    bkStatus: yup.string(),
    bkChapter: yup.string(),
    bkCaseNum: yup.string(),
    priorBankruptcy: yup.string(),
    bkFileBy: yup.string(),
  };

  if (
    !isStrEmptyOrNull(value.bkCaseNum) ||
    !isStrEmptyOrNull(value.bkChapter) ||
    !isStrEmptyOrNull(value.bkStatus) ||
    !isStrEmptyOrNull(value.priorBankruptcy) ||
    !isStrEmptyOrNull(value.bkFileBy) ||
    !isStrEmptyOrNull(value.dates.bkFileDate) ||
    !isStrEmptyOrNull(value.dates.priorBankruptcyFiledDate)
  ) {
    shapeObject.dates = shapeObject.dates.shape({
      bkFileDate: yup.string().required('Bankruptcy File Date must be filled out to edit Bankruptcy fields.'),
    });
    shapeObject.bkCaseNum = yup
      .string()
      .required('Bankruptcy Case Number must be filled out to edit Bankruptcy fields');
    shapeObject.bkChapter = yup.string().required('Bankruptcy Chapter must be filled out to edit Bankruptcy fields');
    shapeObject.bkStatus = yup.string().required('Bankruptcy Status must be filled out to edit Bankruptcy fields');
    shapeObject.priorBankruptcy = yup
      .string()
      .required('Prior Bankruptcy must be filled out to edit Bankruptcy fields');
    shapeObject.bkFileBy = yup.string().required('Bankruptcy Filed By must be filled out to edit Bankruptcy fields');
  }
  if (value.priorBankruptcy == 'Y') {
    shapeObject.dates = shapeObject.dates.shape({
      priorBankruptcyFiledDate: yup
        .string()
        .required('Prior Bankruptcy File Date must be filled out if Prior Bankruptcy is Yes.'),
    });
  }

  if (!isStrEmptyOrNull(value.DDSCode)) {
    shapeObject.dates = shapeObject.dates.shape({
      DDSEventDate: yup.string().required('DDS Date must be filled out to add a DDS code.'),
      DDSReportingDate: yup.string().required('DDS Reporting Date must be filled out to add a DDS Code.'),
    });
  }

  if (!isStrEmptyOrNull(value.investorDDSCode)) {
    shapeObject.dates = shapeObject.dates.shape({
      investorDDSReportingDate: yup
        .string()
        .required('Investor DDS Reporting Date must be filled out to add an investor DDS code.'),
      investorDDSEventDate: yup
        .string()
        .required('Investor DDS Event Date must be filled out to add an investor DDS code.'),
    });
  }

  if (
    !isStrEmptyOrNull(value.investorLoanTypeKeyword) &&
    value.investorLoanTypeKeyword.startsWith('FHLMC') &&
    !isStrEmptyOrNull(value.fhlmcCutoffActionCode)
  ) {
    shapeObject.dates = shapeObject.dates.shape({
      CutoffActionDate: yup
        .string()
        .required('Cutoff Action Date must be filled out to set the FHLMC Cutoff Action Code.'),
      CutoffActionReportingDate: yup
        .string()
        .required('Reporting Date must be filled out to set the FHLMC Cutoff Action Code.'),
    });
  }
  return yup.object().shape({
    ...shapeObject,
  });
});
